import React, { useState } from 'react';
import {
	Grid,
	List,
	ListItem,
	ListItemAvatar,
	Avatar,
	ListItemText,
	IconButton,
	Badge,
	Tooltip,
	TextField,
	Alert,
} from '@mui/material';
import { HeaderSection, setColorStyle } from './BiasInfo';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import {
	justCentered,
	columnStyle,
	rowStyle,
	sortABC,
	adminAreas,
	whichStatus,
	whichStatusColor,
} from '../../../helpers/utils';
import { LinearWithValueLabel } from '../../orders/ProgressBar';
import { PieChart } from './Charts/PieChart';
import { SubBiasForm } from './SubBiasForm';
import { blue } from '@mui/material/colors';
import { useEffect } from 'react';
import {
	deleteSubBias,
	getSubBiases,
	addBias,
	getSubBiasInfo,
	setBiases,
} from '../../../actions/biases';
import { useDispatch, useSelector } from 'react-redux';
import Label from '../../utils/Label';
import { formatDateMX } from '../../../helpers/hours';

// SUBBIASES (SIZES) & STATISTICS
export const SubbiasStatisticsColumn = ({
	bias = null,
	setCurrentSubbias = null,
	counterBiasRow = null,
	currentSubbias = null,
}) => {
	// Lists
	const [sizesKeys2, setSizesKeys] = useState([]);
	const [subbiasesList, setSubbiasesList] = useState([]);

	// States
	const [usingForm, setUsingForm] = useState(false);
	const [fullView, setFullView] = useState(true);

	// Store
	const { user } = useSelector((state) => state);
	const { biases: sizesKeys = [], updateSubbiasesFlag } = useSelector(
		(state) => state.biases
	);

	// Get subbiases from bias id
	const getData = () => {
		getSubBiases(bias.id).then(({ data }) => {
			if (data?.count > 0) {
				// Map results
				const subbiasFiltered = data.results.map((subbias) => ({
					id: subbias.id,
					key: subbias.key,
					progress: subbias.progress,
					size: subbias.size,
					units: subbias.units,
					bias: subbias.bias,
					status: {
						key: subbias.status,
						name: whichStatus(subbias.status),
						color: whichStatusColor(subbias.status),
					},
					delivery_forecast: formatDateMX(subbias?.delivery_forecast),
				}));

				// Assign results
				setSubbiasesList(subbiasFiltered);
			} else {
				setSubbiasesList([]);
			}
		});
	};

	useEffect(() => {
		getData();
	}, [updateSubbiasesFlag, bias]);

	return (
		<Grid
			item
			xs={4}
			style={{
				...setColorStyle('green'),
				height: '100%',
			}}
		>
			{subbiasesList?.length > 0 || usingForm ? (
				<Grid
					container
					style={{
						...setColorStyle('red'),
						height: '100%',
					}}
				>
					<Grid
						item
						xs={12}
						style={{
							...setColorStyle('blue'),
							padding: '15px',
						}}
					>
						{usingForm && bias ? (
							<>
								{/* Subbias form */}
								<SubBiasForm
									bias={bias}
									idSubBias={currentSubbias?.id}
									setUsingForm={setUsingForm}
									refresh={getData}
									subbiasesList={subbiasesList}
								/>
							</>
						) : (
							<>
								{/* Subbiases List */}
								<SubbiasList
									sizesKeys={sizesKeys}
									subbiasesList={subbiasesList}
									setUsingForm={setUsingForm}
									fullView={fullView}
									setFullView={setFullView}
									setCurrentSubbias={setCurrentSubbias}
									currentSubbias={currentSubbias}
									refresh={getData}
								/>
							</>
						)}

						<hr />

						{/* CHART */}
						{!fullView && user?.area?.id !== 3 && (
							<Chart subbiasesList={subbiasesList} />
						)}
					</Grid>
				</Grid>
			) : (
				<div style={{ margin: '1rem 0 0 0' }}>
					{/* HEADER */}
					<HeaderSection text='Tallas' />

					<div
						style={{
							...justCentered,
							...rowStyle,
							justifyContent: 'space-evenly',
							width: '100%',
						}}
					>
						{/* BUTTON */}
						{/* Mesa de control, Asesor and Admin */}
						{(user?.area?.id === 1 ||
							[1, 2, 5].includes(user?.user_type?.id)) && (
							<Tooltip title='Nueva talla'>
								<IconButton
									style={{
										color: '#1976d2',
										// margin: '0 1px 0 0',
									}}
									edge='end'
									aria-label='info'
									onClick={() => {
										setUsingForm((usingForm) => !usingForm);
									}}
								>
									<AddIcon />
								</IconButton>
							</Tooltip>
						)}
					</div>

					<Alert style={{ margin: '20px 0 0 0' }} severity='info'>
						Aún no hay tallas
					</Alert>
				</div>
			)}
		</Grid>
	);
};

const SubbiasList = ({
	sizesKeys = null,
	subbiasesList = [],
	setUsingForm = null,
	fullView = null,
	setFullView = null,
	setCurrentSubbias = null,
	currentSubbias = null,
	refresh = null,
}) => {
	const [subbiasFilter, setSubbiasFilter] = useState([]);
	const [isSearching, setIsSearching] = useState(false);
	const [searchText, setSearchText] = useState('');

	useEffect(() => {
		setSubbiasFilter(sortABC(subbiasesList, 'key'));
	}, [subbiasesList]);

	// Message
	const [msgText, setMsgText] = useState('');
	const [isMsgSent, setIsMsgSent] = useState(null);

	// Select all state
	const [areAllSelected, setAreAllSelected] = useState(false);

	// Dispatch
	const dispatch = useDispatch();

	// Store: user
	const { user = null } = useSelector((state) => state);

	// Feedback message control
	const feedbackMessage = (ok, msg) => {
		setIsMsgSent(ok);
		setMsgText(msg);
		refresh();
		setTimeout(() => {
			setMsgText('');
			setIsMsgSent(null);
			setUsingForm(false);
		}, 2000);
	};

	// Refresh one subbias
	const handleRefreshSubbias = () => {
		if (currentSubbias) {
			getSubBiasInfo(currentSubbias.id).then(({ data }) => {
				const updatedSubbias = data;

				// Update current subbias
				setCurrentSubbias(updatedSubbias); // Very important line

				let tmp = subbiasesList;
				const ids = subbiasesList.map((item) => item.id);
				const currentSubbiasIndex = ids.indexOf(updatedSubbias.id);

				// Update subbiases
				tmp[currentSubbiasIndex] = {
					id: updatedSubbias.id,
					key: updatedSubbias.key,
					progress: updatedSubbias.progress,
					size: updatedSubbias.size,
					units: updatedSubbias.units,
					bias: updatedSubbias.bias,
					status: {
						key: updatedSubbias.status,
						name: whichStatus(updatedSubbias.status),
						color: whichStatusColor(updatedSubbias.status),
					},
					delivery_forecast: formatDateMX(
						updatedSubbias?.delivery_forecast
					),
					delivery_forecast_original:
						updatedSubbias?.delivery_forecast,
				};
				setSubbiasFilter(sortABC(tmp, 'key'));
			});
		}
	};

	useEffect(() => {
		if (currentSubbias?.newProgresses) {
			if (currentSubbias?.newProgresses === 'one') {
				// Update one subbias
				console.log('Update one subbias');
				handleRefreshSubbias();
			} else {
				// Update all subbiases
				console.log('Update all subbiases');
				refresh();
			}
		}
	}, [currentSubbias]);

	useEffect(() => {
		if (isSearching) {
			if (searchText.length > 0) {
				const dataFiltered = subbiasesList.filter(
					(item) =>
						item.key
							.toLowerCase()
							.includes(searchText.toLowerCase()) ||
						item.size.name
							.toLowerCase()
							.includes(searchText.toLowerCase())
				);
				setSubbiasFilter(sortABC(dataFiltered, 'key'));
			} else {
				setSubbiasFilter(sortABC(subbiasesList, 'key'));
			}
		}
	}, [searchText]);

	const handleDelete = (id) => {
		const currentSubbias = subbiasesList.find((item) => item.id === id);
		deleteSubBias(id, {
			...currentSubbias,
			status: currentSubbias.status.key,
			delivery_forecast: currentSubbias.delivery_forecast_original,
		})
			.then(() => {
				feedbackMessage(true, 'Talla eliminada correctamente.');
			})
			.catch((error) => {
				console.log(error);
				feedbackMessage(false, 'No se pudo eliminar la talla.');
			});
	};

	return (
		<>
			{user && (
				<>
					{' '}
					<div style={{ ...justCentered, ...columnStyle }}>
						{/* HEADER */}
						<HeaderSection
							text={`Tallas (${subbiasFilter.length})`}
						/>

						<div
							style={{
								...justCentered,
								...rowStyle,
								justifyContent: 'space-evenly',
								width: '25%',
							}}
						>
							{/* BUTTON */}
							{/* Mesa de control or Asesor */}
							{(user?.area?.id === 1 ||
								[1, 2, 5].includes(user?.user_type?.id)) && (
								<Tooltip title='Nueva talla'>
									<IconButton
										style={{
											color: '#1976d2',
											// margin: '0 1px 0 0',
										}}
										edge='end'
										aria-label='info'
										onClick={() => {
											setUsingForm(
												(usingForm) => !usingForm
											);
										}}
									>
										<AddIcon />
									</IconButton>
								</Tooltip>
							)}

							{subbiasesList.length >= 3 && (
								<Tooltip
									title={
										fullView
											? 'Vista reducida'
											: 'Vista completa'
									}
								>
									<IconButton
										style={{
											color: '#1976d2',
											// margin: '0 1px 0 0',
										}}
										edge='end'
										aria-label='info'
										onClick={() => {
											setFullView(
												(fullView) => !fullView
											);
										}}
									>
										{fullView ? (
											<FullscreenExitIcon />
										) : (
											<FullscreenIcon />
										)}
									</IconButton>
								</Tooltip>
							)}

							<Tooltip title='Buscar'>
								<IconButton
									style={{
										color: '#1976d2',
										// margin: '0 1px 0 0',
									}}
									edge='end'
									aria-label='info'
									onClick={() => {
										if (isSearching) {
											// Reset filter
											setSubbiasFilter(
												sortABC(subbiasesList, 'key')
											);
											setSearchText('');
										}
										// Set is searching state
										setIsSearching(
											(isSearching) => !isSearching
										);
									}}
								>
									{isSearching ? (
										<SearchOffIcon />
									) : (
										<SearchIcon />
									)}
								</IconButton>
							</Tooltip>

							{!adminAreas.includes(user?.area?.name) &&
								user?.user_type?.name === 'Operador' && (
									<Badge
										badgeContent={sizesKeys.length}
										color='primary'
									>
										<Tooltip title='Seleccionar todos'>
											<IconButton
												style={{
													color: '#1976d2',
												}}
												edge='end'
												aria-label='info'
												onClick={() => {
													if (areAllSelected) {
														dispatch(setBiases([]));
													} else {
														setCurrentSubbias(null);
														dispatch(
															setBiases(
																subbiasFilter.map(
																	(item) =>
																		item.id
																)
															)
														);
													}
													setAreAllSelected(
														!areAllSelected
													);
												}}
											>
												<FactCheckOutlinedIcon />
											</IconButton>
										</Tooltip>
									</Badge>
								)}
						</div>

						{/* Alert message */}
						{isMsgSent !== null && msgText.length > 0 && (
							<Alert
								severity={isMsgSent ? 'success' : 'error'}
								style={{ margin: '30px 0 0 0' }}
							>
								{msgText}
							</Alert>
						)}

						{/* Search text field */}
						{isSearching && (
							<TextField
								fullWidth
								autoFocus
								variant='standard'
								label='Buscar folio'
								value={searchText}
								onChange={({ target }) =>
									setSearchText(target.value)
								}
							/>
						)}
					</div>
					<div
						style={{
							margin: '10px 0 0 0',
							maxHeight:
								subbiasesList?.length > 0
									? `${fullView ? '70' : '34'}vh`
									: '100vh',
							overflow: 'scroll',
							overflowX: 'hidden',
						}}
					>
						<List dense>
							{subbiasFilter.map((subbias) => (
								<div
									key={subbias.key}
									style={{ margin: '0 0 15px 0' }}
								>
									<ListItem
										secondaryAction={
											<>
												{/* Admin, Manager and Consultant */}
												{/* Mesa de control and Logistics are not allowed */}
												{![2, 3, 5].includes(
													user?.user_type?.id
												) &&
													![1, 3].includes(
														user?.area?.id
													) && (
														<Tooltip
															title={
																subbias.progress ===
																100
																	? 'La talla está completada'
																	: 'Seleccionar'
															}
														>
															{/* "Span" tag is needed because of the disabling of the button */}
															<span>
																<IconButton
																	style={{
																		color: '#1976d2',
																	}}
																	edge='end'
																	disabled={
																		subbias.progress ===
																		100
																	}
																	aria-label='info'
																	onClick={() => {
																		if (
																			sizesKeys.includes(
																				subbias.id
																			)
																		) {
																			const newSizesKeys =
																				sizesKeys.filter(
																					(
																						item
																					) =>
																						item !==
																						subbias.id
																				);
																			dispatch(
																				setBiases(
																					newSizesKeys
																				)
																			);
																		} else {
																			const newSizesKeys =
																				[
																					...sizesKeys,
																					subbias.id,
																				];
																			dispatch(
																				setBiases(
																					newSizesKeys
																				)
																			);
																		}
																		setCurrentSubbias(
																			null
																		);
																	}}
																>
																	{subbias.progress ===
																	100 ? (
																		<IndeterminateCheckBoxOutlinedIcon />
																	) : sizesKeys.includes(
																			subbias.id
																	  ) ? (
																		<CheckBoxIcon />
																	) : (
																		<CheckBoxOutlineBlankIcon />
																	)}
																</IconButton>
															</span>
														</Tooltip>
													)}

												{/* Everyone can see the subbias' track info */}
												<Tooltip
													title={
														sizesKeys.length > 0
															? 'Estás seleccionando tallas'
															: 'Ver información'
													}
												>
													<span
														style={{
															marginRight: '10px',
														}}
													>
														<IconButton
															disabled={
																sizesKeys.length >
																0
															}
															style={{
																color: '#1976d2',
															}}
															edge='end'
															aria-label='info'
															onClick={() => {
																if (
																	currentSubbias?.key ===
																	subbias.key
																) {
																	setCurrentSubbias(
																		null
																	);
																} else {
																	setCurrentSubbias(
																		subbias
																	);
																}
															}}
														>
															{currentSubbias?.key ===
															subbias.key ? (
																<VisibilityOffIcon />
															) : (
																<InfoIcon />
															)}
														</IconButton>
													</span>
												</Tooltip>

												{/* Mesa de control, Asesor and Admin */}
												{(user?.area?.id === 1 ||
													[1, 2, 5].includes(
														user?.user_type?.id
													)) && (
													<Tooltip title='Eliminar'>
														<IconButton
															color='error'
															edge='end'
															aria-label='delete'
															onClick={() => {
																handleDelete(
																	subbias.id
																);
															}}
														>
															<DeleteIcon />
														</IconButton>
													</Tooltip>
												)}
											</>
										}
									>
										{/* Avatar */}
										<ListItemAvatar>
											<Avatar sx={{ bgcolor: blue[700] }}>
												<CheckroomIcon />
											</Avatar>
										</ListItemAvatar>
										{/* Info */}
										<ListItemText
											primary={subbias.key}
											secondary={`Talla: ${subbias.size.name} | Unidades: ${subbias.units}`}
										/>
									</ListItem>
									<div
										style={{
											width: '70%',
											margin: '0 auto',
										}}
									>
										{/* Status */}
										<Label
											color={subbias?.status?.color}
											sx={{
												width: '45%',
												margin: '10px 0',
											}}
										>
											{subbias?.status?.name}
										</Label>
										<br />
										<small style={{ color: 'gray' }}>
											<b>Fecha estimada:</b>{' '}
											{subbias?.delivery_forecast}
										</small>
										<LinearWithValueLabel
											progress={subbias.progress}
										/>
									</div>
									<hr />
								</div>
							))}
						</List>
					</div>
				</>
			)}
		</>
	);
};

const Chart = ({ subbiasesList = null }) => {
	const handleFilterStatus = (status) =>
		subbiasesList.filter((subbias) => subbias.status.key === status);

	const values = {
		delayed: handleFilterStatus('DLY').length,
		inProgres: handleFilterStatus('IPR').length,
		notStarted: handleFilterStatus('NST').length,
		finished: handleFilterStatus('FIN').length,
	};

	return (
		<>
			<HeaderSection text='Datos de las tallas' />
			<div
				style={{
					margin: '10px 0 0 0',
					maxHeight: '34vh',
					...justCentered,
					...columnStyle,
				}}
			>
				<PieChart values={values} />
			</div>
		</>
	);
};
